import { render, staticRenderFns } from "./FollowedIcon.vue?vue&type=template&id=2fab1c9d&"
import script from "./FollowedIcon.vue?vue&type=script&lang=ts&"
export * from "./FollowedIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports